export default "__VITE_ASSET__f92decc6__"